import { getToken, userLogin, getCurrentUserMenuTree } from '../api/login';
import { getCookie, setCookie } from 'cookieUtils';
import { stringify } from 'querystringify'; // 引入 stringify
import { CRM_TOKEN, CRM_MENU, CRM_USER_INFO, CRM_USER_DEPARTMENT, CRM_PROVICE_CITY, CRM_CLUES_STATUS, CRM_INTENTION_DEGREE, CRM_CUSTONER_SOURE, CRM_CHANNERLS, CRM_CLUES_OPTIMAL, CRM_PROFESSIONAL_STATUS, CRM_TRAFFIC_STATUS, CRM_LABE_LIST, CRM_URGENCY, CRM_INTENTTION_DEGREE, CRM_CERTIFICATES_TYPE, CRM_INTENTION_STUDENTS } from './keys';
import { getEnv } from './config'; // 引入 getEnv
import { Message } from 'element-ui';

export async function handleLogin({ ssoToken, account, password, router }) {
    let tokenRet;

    // 获取 GDSID 参数
    const GDSID = getGDSID();

    // 如果是 ssoToken 登录
    if (ssoToken) {
        tokenRet = await getToken(stringify({ ssoToken })).catch(() => null);
    } else {
        // 如果是账号密码登录，使用 stringify 对参数进行序列化
        tokenRet = await getToken(
            stringify({
                grant_type: 'password',
                UserName: account,
                Password: password,
                GDSID: GDSID || '', // 如果 GDSID 存在则添加，否则为空字符串
            })
        ).catch(() => null);
    }

    if (tokenRet && tokenRet.access_token) {
        setCookie(CRM_TOKEN, tokenRet.access_token);

        // 登录
        const loginParams = ssoToken ? { ssoToken } : { Account: account, Password: password };
        const loginRet = await userLogin(loginParams).catch(() => null);

        if (loginRet && loginRet.status === 0) {
            const { UserId, Email, TrueName, PwdType, HomePage } = loginRet.result;

            // 埋点方法
            window.sa.trackSignup(UserId.toString(), 'signup');
            window.sa.identify(UserId.toString(), true);
            window.sa.setProfile({ Email, TrueName });

            localStorage.setItem(CRM_USER_INFO, JSON.stringify(loginRet.result));

            // 清理 sessionStorage 中的相关数据
            clearSessionStorage();

            // 获取菜单树
            const menuRet = await getCurrentUserMenuTree();
            if (menuRet && menuRet.status === 0) {
                const menu = menuRet.result;
                // 对于没有权限的菜单，进行提示
                if (!menu) {
                    Message({
                        message: '阿哦，您没有能访问的菜单权限，请前往[手机钉钉App > 权限申请应用]提交申请。',
                        type: 'warning',
                        duration: 7 * 1000
                    });
                    router.push({ path: '/cluesIndex', query: { nw: 0 } });
                    return;
                }
                reWriteEmptyUrl(menu); // 调用 reWriteEmptyUrl 函数
                localStorage.setItem(CRM_MENU, JSON.stringify(menu));
                
                // 根据密码类型和首页跳转逻辑进行路由跳转（非sso跳转）
                // if (PwdType === 0) {
                    if (!HomePage || HomePage === '') {
                        router.push({ path: '/cluesIndex' });
                    } else {
                        router.push({ path: HomePage });
                    }
                // } else {
                //     router.push({ path: '/updatePwd?NavigationId=520&nw=1' });
                // }
            }

            return loginRet.result; // 返回登录结果
        }
    }

    throw new Error('登录失败');
}

// 获取 GDSID 参数
function getGDSID() {
    const prefix = getEnv();
    const gdsid = getCookie(`${prefix}GDSID`);
    return gdsid || ''; // 返回空字符串以避免接口报错
}

// 清理 sessionStorage 中的相关数据
function clearSessionStorage() {
    sessionStorage.removeItem(CRM_USER_DEPARTMENT);
    sessionStorage.removeItem(CRM_PROVICE_CITY);
    sessionStorage.removeItem(CRM_CLUES_STATUS);
    sessionStorage.removeItem(CRM_INTENTION_DEGREE);
    sessionStorage.removeItem(CRM_CUSTONER_SOURE);
    sessionStorage.removeItem(CRM_CHANNERLS);
    sessionStorage.removeItem(CRM_CLUES_OPTIMAL);
    sessionStorage.removeItem(CRM_PROFESSIONAL_STATUS);
    sessionStorage.removeItem(CRM_TRAFFIC_STATUS);
    sessionStorage.removeItem(CRM_LABE_LIST);
    sessionStorage.removeItem(CRM_URGENCY);
    sessionStorage.removeItem(CRM_INTENTTION_DEGREE);
    sessionStorage.removeItem(CRM_CERTIFICATES_TYPE);
    sessionStorage.removeItem(CRM_INTENTION_STUDENTS);
}

// 递归处理菜单树中的空 URL
function reWriteEmptyUrl(menu) {
    for (let i in menu) {
        if (menu[i].Url === "") {
            menu[i].Url = Math.random().toString();
        }
        if (menu[i].Url.indexOf('Report') > -1) {
            menu[i].Url = menu[i].Url.replace(/http.*key=/, '/Report/');
        }
        if (menu[i].ChildNavigations) {
            reWriteEmptyUrl(menu[i].ChildNavigations);
        }
    }
}